import { useRef, useState } from "react";
import { useContent } from "@/contexts/ContentContext";
import { CMS } from "@/constants/testIds/cms";

const DEFAULT_SEAL = { x: -205, y: -18, scale: 1.6 };

export function SealEditor() {
  const { editMode, getByPath, setPath } = useContent();
  const seal = getByPath("hero.seal") || DEFAULT_SEAL;
  const svgRef = useRef(null);
  const dragRef = useRef(null);
  const [live, setLive] = useState(null);

  const current = live || seal;

  function handlePointerDown(e) {
    if (!editMode) return;
    e.preventDefault();
    e.stopPropagation();
    const rect = svgRef.current.getBoundingClientRect();
    const scaleFactor = 340 / rect.width;
    dragRef.current = { startClientX: e.clientX, startClientY: e.clientY, startX: seal.x, startY: seal.y, scaleFactor };
    setLive({ x: seal.x, y: seal.y });
    window.addEventListener("mousemove", handlePointerMove);
    window.addEventListener("mouseup", handlePointerUp);
  }

  function handlePointerMove(e) {
    const d = dragRef.current;
    if (!d) return;
    const dx = (e.clientX - d.startClientX) * d.scaleFactor;
    const dy = (e.clientY - d.startClientY) * d.scaleFactor;
    setLive({ x: d.startX + dx, y: d.startY + dy });
  }

  function handlePointerUp() {
    window.removeEventListener("mousemove", handlePointerMove);
    window.removeEventListener("mouseup", handlePointerUp);
    setLive((finalLive) => {
      if (finalLive) {
        setPath("hero.seal.x", Math.round(finalLive.x));
        setPath("hero.seal.y", Math.round(finalLive.y));
      }
      return null;
    });
    dragRef.current = null;
  }

  function adjustScale(delta) {
    const next = Math.max(0.5, Math.min(3, Math.round((seal.scale + delta) * 100) / 100));
    setPath("hero.seal.scale", next);
  }

  function resetSeal() {
    setPath("hero.seal", { ...DEFAULT_SEAL });
  }

  return (
    <div className="seal-wrap">
      <div className="seal">
        <svg ref={svgRef} viewBox="0 0 340 340">
          <circle className="seal-ring outer" cx="170" cy="170" r="164" />
          <circle className="seal-ring inner" cx="170" cy="170" r="150" />
          <g
            transform={`translate(${current.x},${current.y}) scale(${seal.scale})`}
            className={editMode ? "seal-crane-draggable" : ""}
            onMouseDown={handlePointerDown}
            data-testid={CMS.sealDragHandle}
          >
            <rect x="150" y="55" width="170" height="125" fill="rgba(0,0,0,0.001)" />
            <use href="#crane-mark" />
          </g>
        </svg>
        {editMode && (
          <div className="seal-controls" data-testid={CMS.sealControls}>
            <button type="button" onClick={() => adjustScale(-0.1)} data-testid={CMS.sealZoomOut} title="Shrink crane">
              −
            </button>
            <span>Drag crane to move</span>
            <button type="button" onClick={() => adjustScale(0.1)} data-testid={CMS.sealZoomIn} title="Enlarge crane">
              +
            </button>
            <button type="button" onClick={resetSeal} data-testid={CMS.sealReset} title="Reset position and size">
              Reset
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
